import Swal from 'sweetalert2';

/**
 * Controlar los errores de validaciones.
 *
 * @param {object} errors
 * @returns {boolean}
 * @author Fernando Claros
 */
export function controlErrorsCallback(errors) {

  try {

    if ('errors' in errors && typeof errors.errors === 'object' && 'status' in errors && [404, 422, 400].includes(errors.status)) {

      let errorsText = "<ul style='text-align:left !important;'>";
      Object.values(errors.errors).forEach(item => errorsText += `<li style='font-size: 16px !important; text-align:left !important;'><i>${item}</i></li>`);
      errorsText += "</ul>";

      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error de validación',
        html: errorsText,
        showConfirmButton: true
      });

      return true;
    }

    return false;

  } catch (e) {
    return false;
  }
}